import qs from 'qs';
import axios from 'axios';
import {Loading, MessageBox} from 'element-ui'
import {merge} from '../../util'
import OnceMessage from '../../components/once-message/once-message'
import {HeaderBuilder} from './header'

let athubAxios = axios.create({
    timeout: 120000, // 超时时间：2分钟
    crossDomain: true,
    withCredentials: false, //设置cross跨域 并设置访问权限 允许跨域携带cookie信息
});
athubAxios._request = athubAxios.request;
athubAxios._get = athubAxios.get;
athubAxios._post = athubAxios.post;
athubAxios._put = athubAxios.put;
athubAxios._patch = athubAxios.patch;
athubAxios._delete = athubAxios.delete;
athubAxios._head = athubAxios.head;
athubAxios._options = athubAxios.options;

function autoHeaders(headers, key, value) {
    if ((headers[key] == null || String(headers[key]).trim() === '') && value != null) {
        headers[key] = value;
    }
    return headers;
}

function getDefaultAthubConfig() {
    let headers = {};
    return {
        loading: false,
        headers: headers
    };
}

function getFilename(response, defaultFilename) {
    let filename = defaultFilename || '下载的文件';
    let contentDisposition = response.headers["content-disposition"];
    if (contentDisposition != null) {
        const reg = /filename="([^"]*)"/
        const match = reg.exec(contentDisposition)
        if(match && match.length > 0) {
            filename = decodeURIComponent(match[1])
        }
    }
    return filename;
}

function download(response, defaultFilename) {
    let filename = getFilename(response, defaultFilename);
    let blob = new Blob([response.data], {type: ''});
    let objectUrl = URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.getElementsByTagName("body")[0].appendChild(a);
    a.click();
    a.remove();
}

function executeWrapper(promise, config) {
    return new Promise((resolve, reject) => {
        if (config.loading) {
            startLoading();
        }
        promise.then((res) => {
            if (config.loading) {
                endLoading();
            }
            resolve(res);
        }, (error) => {
            if (config.loading) {
                endLoading();
            }
            reject(error);
        })
    });
}

athubAxios.postByJson = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.json(), athubConfig);
    return executeWrapper(athubAxios._post(url, JSON.stringify(data), config), config);
};
athubAxios.postByForm = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.form(), athubConfig);
    return executeWrapper(athubAxios._post(url, qs.stringify(data), config), config);
};
athubAxios.postByMultipartForm = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.multipartForm(), athubConfig);
    let formData = new FormData();
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, data[key]);
        }
    }
    return executeWrapper(athubAxios._post(url, formData, config), config);
};

athubAxios.putByJson = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.json(), athubConfig);
    return executeWrapper(athubAxios._put(url, JSON.stringify(data), config), config);
};
athubAxios.putByForm = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.form(), athubConfig);
    return executeWrapper(athubAxios._put(url, qs.stringify(data, { skipNulls: true }), config), config);
};
athubAxios.putByMultipartForm = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.multipartForm(), athubConfig);
    let formData = new FormData();
    for (let key of data) {
        formData.append(key, data[key]);
    }
    return executeWrapper(athubAxios._put(url, formData, config), config);
};

athubAxios.patchByJson = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.json(), athubConfig);
    return executeWrapper(athubAxios._patch(url, JSON.stringify(data), config), config);
};
athubAxios.patchByForm = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.form(), athubConfig);
    return executeWrapper(athubAxios._patch(url, qs.stringify(data), config), config);
};
athubAxios.patchByMultipartForm = function (url, data, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.multipartForm(), athubConfig);
    let formData = new FormData();
    for (let key of data) {
        formData.append(key, data[key]);
    }
    return executeWrapper(athubAxios._patch(url, formData, config), config);
};

athubAxios.get = function (url, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), athubConfig);
    return executeWrapper(athubAxios._get(url, config), config);
};
athubAxios.delete = function (url, athubConfig) {
    let config = merge(true, {}, getDefaultAthubConfig(), athubConfig);
    return executeWrapper(athubAxios._delete(url, config), config);
};
athubAxios.post = athubAxios.postByJson;
athubAxios.put = athubAxios.putByJson;
athubAxios.patch = athubAxios.patchByJson;
athubAxios.download = (url, defaultFilename, athubConfig) => {
    let config = merge(true, {}, getDefaultAthubConfig(), {
        responseType: 'arraybuffer'
    }, athubConfig);
    return new Promise((resolve, reject) => {
        executeWrapper(athubAxios._get(url, config), config).then(res => {
            download(res, defaultFilename);
            resolve(true);
        }, error => {
            reject(error);
        });
    });

};
athubAxios.downloadByPost = (url, body, defaultFilename, athubConfig) => {
    let config = merge(true, {}, getDefaultAthubConfig(), HeaderBuilder.json(), {
        responseType: 'arraybuffer'
    }, athubConfig);
    return new Promise((resolve, reject) => {
        executeWrapper(athubAxios._post(url, body == null ? null : JSON.stringify(body), config), config).then(res => {
            download(res, defaultFilename);
            resolve(true);
        }, error => {
            reject(error);
        });
    });
};

athubAxios.interceptors.request.use(
    config => {
        // window.console.log(`Request Authentication Interceptor `, config);
        // 认证信息
        ['appId', 'token'].forEach((key) => {
            config.headers = autoHeaders(config.headers, key, encodeURIComponent(localStorage.getItem(key)));
        });
        return config;
    },
    error => {
        return Promise.reject(error.response);
    });

// 路由响应拦截
// http response 拦截器
athubAxios.interceptors.response.use(
    response => {
        // endLoading();
        if (response.data.code === "404") {
            console.log("404");
        } else {
            return response;
        }
    },
    error => {
      if (window.navigator.onLine == false) {
        let msg = '当前网络已断开，请检查网络连接！';
        OnceMessage.error(msg);
        error.message = msg;
      }

      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            error.message = '请求错误(400)';
            break;
          case 401:
            missToken();
            break;
          default:
            error.message = `请求出错了，请联系管理员！`;
        }
      } else {
        error.message = '请求出错了，请联系管理员！'
      }
      return Promise.reject(error);
    });

let loadingInstance;

function startLoading() { //使用Element loading-start 方法
    loadingInstance = Loading.service({
        lock: true,
        text: '拼命加载中...',
        background: 'rgba(255,255,255,0)',
    })
}

function endLoading() { //使用Element loading-close 方法
    loadingInstance.close();
}

function missToken() {
    // let loginPageUrl = process.env.VUE_APP_SERVICE_IP_PORT + '/welcome.jsp';
    // let loginPageUrl = process.env.VUE_APP_WEB_API + '/login.html' ;
    let loginPageUrl = process.env.VUE_APP_WEB_API + '/v3/login' ;
    // MessageBox.alert(`当前登陆已被重置，请重新登陆！`, '警告', {
    //     confirmButtonText: '确定',
    //     type: 'error'
    // }).then(() => {
    //     window.console.log(loginPageUrl);
    //     window.location.href = loginPageUrl;
    // });
    window.location.href = loginPageUrl;
}

export default athubAxios;
